import { Injectable, isDevMode } from '@angular/core';
import feathers from '@feathersjs/client';
import io from 'socket.io-client';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MARKET_CHAT_URL } from '@Env/environment';

@Injectable({ providedIn: 'root' })
export class MarketFeathersService {
  private readonly _feathers: any = feathers();
  private readonly _socket = io(MARKET_CHAT_URL, {
    transports: ['websocket'],
    timeout: 5000,
    forceNew: true,
  });
  private readonly _currentUserSubject = new BehaviorSubject<any>(null);
  private connected = false;

  constructor() {
    this.connect();
  }

  get currentUserSubject(): BehaviorSubject<any> {
    return this._currentUserSubject;
  }

  isAuthChat(): Observable<boolean> {
    return this._currentUserSubject.pipe(
      filter((user) => Object.keys(user || {}).length !== 0),
      map((data) => !!data)
    );
  }

  connect(): void {
    if (!MARKET_CHAT_URL || this.connected) {
      return;
    }

    this._feathers
      .configure(feathers.socketio(this._socket, { timeout: 50000 }))
      .configure(
        feathers.authentication({
          storageKey: 'market_token',
          scheme: 'Bearer',
        })
      );

    this.connected = true;
  }

  service(name: string): any {
    return this._feathers.service(name);
  }

  authenticate(token: string): Observable<any> {
    try {
      localStorage.setItem('market_token', token);
    } catch {
      /* ignore */
    }

    return from(
      this._feathers.authenticate({
        strategy: 'jwt',
        accessToken: token,
      }) as Promise<any>
    ).pipe(
      map((data: any) => {
        if (data?.user) {
          this._currentUserSubject.next(data.user);
        }
        return data;
      })
    );
  }

  logout(): any {
    if (isDevMode()) {
      return this._feathers.logout();
    }
  }
}
